import { useState } from "react";
import { Card, Badge, Accordion, Form, Button } from "react-bootstrap";
import { ArrowsExpand, ArrowsCollapse } from "react-bootstrap-icons";

export default function TargetLocalesSelector({
  groupedLocales,
  filteredLocales,
  targetLanguageIds,
  setTargetLanguageIds,
  showExtraLocales,
  setShowExtraLocales
}) {

  const [activeKeys, setActiveKeys] = useState([]);

  function toggleAll(expand) {
    if (expand) {
      setActiveKeys(Object.keys(groupedLocales).map((_, i) => String(i)));
    } else {
      setActiveKeys([]);
    }
  }

  function getRegionSelectionCount(locales) {
    return locales.filter(l => targetLanguageIds.includes(l.id)).length;
  }

  function toggleLocale(id) {
    setTargetLanguageIds(prev =>
      prev.includes(id)
        ? prev.filter(l => l !== id)
        : [...prev, id]
    );
  }

  return (
    <Card className="shadow-sm border-0 rounded-4 mb-4">
      <Card.Body className="p-4">

        <h5 className="fw-bold mb-4 text-primary d-flex align-items-center">
          <Badge bg="primary" className="me-3 rounded-circle">2</Badge>
          Target Locales
        </h5>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="fw-bold small text-muted">
            LOCALES: {filteredLocales.length} AVAILABLE / {targetLanguageIds.length} SELECTED
          </div>

          <div className="d-flex gap-2">
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => toggleAll(true)}
            >
              <ArrowsExpand size={14} /> Expand All
            </Button>

            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => toggleAll(false)}
            >
              <ArrowsCollapse size={14} /> Collapse All
            </Button>

            <Form.Check
              type="switch"
              label="Bypass Filters"
              checked={showExtraLocales}
              onChange={e => setShowExtraLocales(e.target.checked)}
              className="ms-2"
            />
          </div>
        </div>

        <div className="custom-scroll-container border rounded-4 p-2 bg-light">

          <Accordion activeKey={activeKeys} onSelect={setActiveKeys} alwaysOpen>

            {Object.keys(groupedLocales).map((region, idx) => {

              const locales = groupedLocales[region];
              const selectedCount = getRegionSelectionCount(locales);

              return (
                <Accordion.Item
                  eventKey={String(idx)}
                  key={region}
                  className="border-0 border-bottom bg-transparent"
                >

                  <Accordion.Header>
                    <div className="d-flex justify-content-between w-100 pe-3">
                      <span className="fw-bold small">{region}</span>

                      <Badge
                        bg={selectedCount > 0 ? "primary" : "light"}
                        text={selectedCount > 0 ? "white" : "dark"}
                        pill
                      >
                        {selectedCount} / {locales.length}
                      </Badge>
                    </div>
                  </Accordion.Header>

                  <Accordion.Body className="p-0 bg-white rounded-3 mt-1 mx-2 mb-2 shadow-sm">

                    {locales.map(lang => (
                      <div
                        key={lang.id}
                        className="p-3 border-bottom d-flex align-items-center"
                      >
                        <Form.Check
                          id={`l-${lang.id}`}
                          label={`${lang.flag} ${lang.name}`}
                          checked={targetLanguageIds.includes(lang.id)}
                          onChange={() => toggleLocale(lang.id)}
                          className="w-100"
                        />
                      </div>
                    ))}

                  </Accordion.Body>
                </Accordion.Item>
              );
            })}

          </Accordion>
        </div>

      </Card.Body>
    </Card>
  );
}